import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { Grid, List, ListItem, ListItemText } from "@mui/material";
import Controls from "../../../components/controls/Controls";
import Popup from "../../../components/customHelpers/Popup";
import AddPurchaseProductForm from "../../../components/forms/addPurchaseProduct";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";

const useStyles = makeStyles((theme) => ({
  listItem: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  primaryText: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
}));

const ProductDetails = ({ product, getProductData }) => {
  const { NotifyMessage, notify, setNotify } = Notify();

  const classes = useStyles();

  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);

  return (
    <>
      <List>
        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={<span className={classes.primaryText}>Name</span>}
              />
            </Grid>
            <Grid item xs={9}>
              <ListItemText
                primary={
                  <span className={classes.secondaryText}>{product?.name}</span>
                }
              />
            </Grid>
          </Grid>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={<span className={classes.primaryText}>Type</span>}
              />
            </Grid>
            <Grid item xs={9}>
              <ListItemText
                primary={
                  <span className={classes.secondaryText}>{product?.type}</span>
                }
              />
            </Grid>
          </Grid>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={<span className={classes.primaryText}>Sku</span>}
              />
            </Grid>
            <Grid item xs={9}>
              <ListItemText
                primary={
                  <span className={classes.secondaryText}>{product?.sku}</span>
                }
              />
            </Grid>
          </Grid>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={<span className={classes.primaryText}>Bar Code</span>}
              />
            </Grid>
            <Grid item xs={9}>
              <ListItemText
                primary={
                  <span className={classes.secondaryText}>
                    {product?.bar_code}
                  </span>
                }
              />
            </Grid>
          </Grid>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={<span className={classes.primaryText}>Category</span>}
              />
            </Grid>
            <Grid item xs={9}>
              <ListItemText
                primary={
                  <span className={classes.secondaryText}>
                    {product?.category}
                  </span>
                }
              />
            </Grid>
          </Grid>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <ListItemText
                primary={
                  <span className={classes.primaryText}>Description</span>
                }
              />
            </Grid>
            <Grid item xs={9}>
              <ListItemText
                primary={
                  <span className={classes.secondaryText}>
                    {product?.description}
                  </span>
                }
              />
            </Grid>
          </Grid>
        </ListItem>
        <Controls.Button
          text={"Edit"}
          size="small"
          variant="contained"
          className="Button"
          onClick={() => {
            setOpenPopup(true);
            setEdit(true);
          }}
        />
      </List>
      <Notification notify={notify} setNotify={setNotify} />

      <Popup
        title="Product Form"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <AddPurchaseProductForm
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopup}
          recordForEdit={product}
          getAllProducts={getProductData}
          openPopupUpdate={true}
          edite={edite}
        />
      </Popup>
    </>
  );
};

export default ProductDetails;
